/**
 * ⚙ Nastavení is for the authority administrator only (CZNA-1448, decided 22. 10. 2026).
 *
 * <p>Not a READ of any settings page: a cataloguer legitimately holds
 * `semantic-catalog.get`, `module-settings.form-configs.get` and
 * `module-settings.effective.get` because the record form needs them, so gating on those
 * would show Ontologie and Nastavení formulářů to every cataloguer. This write reaches
 * nobody but AUTHORITY_ADMIN — mod-czna-users grants it only through the admin's
 * `czna-authorities.*` wildcard (`CapabilitySyncService#computePermissionQueries`).
 * The rail entry, the settings routes and the in-form link into the ontology follow it.
 * `hasPerm` is UX only — the backend answers 403 either way.
 */
export var SETTINGS_CAPABILITY = 'czna-authorities.module-settings.item.put';
/**
 * Nastavení → Slovníky — creating and renaming vocabularies (CZNA-1470, rule from CZNA-958).
 *
 * <p>Since CZNA-1635 only the system administrator (AUTHORITY_ADMIN) holds it, through
 * mod-czna-users' `czna-authorities.*` wildcard: the global vocabulary administrator who
 * used to hold it on its own is gone. A per-type role — the Supervizor NK of a vocabulary
 * type included — grants `vocabularies.*` (the terms), never this; so nobody reaches
 * Slovníky without also holding {@link SETTINGS_CAPABILITY}. The page keeps its own gate,
 * the capability the endpoint requires, so the UI follows the server whatever grants it.
 */
export var VOCABULARY_TYPES_CAPABILITY = 'czna-authorities.vocabulary-types.item.post';
/**
 * Nastavení → Sklizeň OAI — who harvests the authority data over OAI-PMH and how often
 * (CZNA-1562). The permission the descriptor puts on `GET /oai/harvest-statistics` and
 * `GET /oai/harvest-log`; mod-czna-users grants it only through the authority
 * administrator's `czna-authorities.*` wildcard. The page, its route and its button
 * gate on it alone, so whoever can read the endpoints sees the page and nobody else.
 */
export var OAI_HARVEST_CAPABILITY = 'czna-authorities.oai.harvest.get';
